import { render } from "./property-summarydetails.vue?vue&type=template&id=5b467a21"
import script from "./property-summarydetails.js?vue&type=script&lang=js"
export * from "./property-summarydetails.js?vue&type=script&lang=js"

import "./property-summarydetails.vue?vue&type=style&index=0&id=5b467a21&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__